import { Typography } from "@mui/material";
import React from "react";

export default function EmptyCard({ type }: { type: string }) {
  return (
    <div className="card empty-data">
      <img src={"/no-data.svg"} alt="no-data" />
      <Typography variant="h6">No {type}</Typography>
      <Typography variant="body1">
        This visit does not include any {type}.
      </Typography>
    </div>
  );
}
